export const applyLogoMask = (dataUrl, mask) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    const SIZE = 256;   // internal canvas resolution
    const canvas = document.createElement('canvas');
    canvas.width  = SIZE;
    canvas.height = mask === 'rect' ? SIZE * 0.6 : SIZE;
    const ctx = canvas.getContext('2d');
    const w = canvas.width;
    const h = canvas.height;

    ctx.clearRect(0, 0, w, h);
    ctx.save();

    if (mask === 'circle') {
      ctx.beginPath();
      ctx.arc(w / 2, h / 2, Math.min(w, h) / 2, 0, Math.PI * 2);
      ctx.closePath();
      ctx.clip();
    } else if (mask === 'rect') {
      // Wide rectangle with rounded corners
      const r = 18;
      ctx.beginPath();
      ctx.moveTo(r, 0); ctx.lineTo(w - r, 0);
      ctx.quadraticCurveTo(w, 0, w, r);
      ctx.lineTo(w, h - r); ctx.quadraticCurveTo(w, h, w - r, h);
      ctx.lineTo(r, h); ctx.quadraticCurveTo(0, h, 0, h - r);
      ctx.lineTo(0, r); ctx.quadraticCurveTo(0, 0, r, 0);
      ctx.closePath();
      ctx.clip();
    } else {
      // Square with slightly rounded corners
      const r = 12;
      ctx.beginPath();
      ctx.moveTo(r, 0); ctx.lineTo(w - r, 0);
      ctx.quadraticCurveTo(w, 0, w, r);
      ctx.lineTo(w, h - r); ctx.quadraticCurveTo(w, h, w - r, h);
      ctx.lineTo(r, h); ctx.quadraticCurveTo(0, h, 0, h - r);
      ctx.lineTo(0, r); ctx.quadraticCurveTo(0, 0, r, 0);
      ctx.closePath();
      ctx.clip();
    }

    // Draw image centred + cover-fit inside the canvas
    const scale = Math.max(w / img.width, h / img.height);
    const dx = (w - img.width  * scale) / 2;
    const dy = (h - img.height * scale) / 2;
    ctx.drawImage(img, dx, dy, img.width * scale, img.height * scale);
    ctx.restore();
    resolve(canvas.toDataURL('image/png'));
  };
  img.src = dataUrl;
});
